import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

/**
 * Component that offers an input field that sends an event on typed input.
 * The event is send by the output decorator 'queryChanged', with a delay that could be customized by giving a
 * 'debounceTime'. The input field is designed as search field.
 */
@Component({
  selector: 'app-search-input-field',
  templateUrl: './search-input-field.component.html',
  styleUrls: ['./search-input-field.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, ReactiveFormsModule],
})
export class SearchInputFieldComponent implements OnInit {
  static readonly DEFAULT_DEBOUNCE_TIME = 300;
  static readonly DEFAULT_PLACEHOLDER_TEXT = '';

  /** delay time in milliseconds until an input is triggered (default: 300 ms) */
  @Input() debounceTime: number;
  /** placeholder text in search input field (default: empty) */
  @Input() placeholder: string;
  @Input() label: string;
  @Input() initialValue: string;
  /** event that is send on changed input (after a customizable debounce time) */
  @Output() queryChanged = new EventEmitter<string>();
  /** event that is send on click on close icon */
  @Output() inputCleared = new EventEmitter<void>();

  searchTerm = new UntypedFormControl();
  searchInput: HTMLInputElement;

  isInFocus = false;

  ngOnInit() {
    this.initInputValues();
    this.searchInput = document.getElementById('typeahead-input') as HTMLInputElement;
    this.searchTerm.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe((query) => {
      this.queryChanged.emit(query);
    });
    this.searchTerm.setValue(this.initialValue);
  }

  clearInput() {
    this.inputCleared.emit();
    this.searchTerm.setValue('');
  }

  onFocus() {
    this.isInFocus = !this.isInFocus;
  }

  setInput(inputString: string) {
    this.searchTerm.setValue(inputString);
  }

  private initInputValues() {
    if (!this.debounceTime) {
      this.debounceTime = SearchInputFieldComponent.DEFAULT_DEBOUNCE_TIME;
    }
    if (!this.placeholder) {
      this.placeholder = SearchInputFieldComponent.DEFAULT_PLACEHOLDER_TEXT;
    }
  }
}
